"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pagination = _interopRequireDefault(require("./pagination"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * An abstraction that provides a simple interface for managing
 * paginated collections of entities from the API.
 **/
var CollectionManager = /*#__PURE__*/function () {
  function CollectionManager() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$list = _ref.list,
        list = _ref$list === void 0 ? [] : _ref$list,
        _ref$pagination = _ref.pagination,
        pagination = _ref$pagination === void 0 ? _pagination["default"].create() : _ref$pagination,
        _ref$refreshing = _ref.refreshing,
        refreshing = _ref$refreshing === void 0 ? false : _ref$refreshing,
        _ref$loadingNextPage = _ref.loadingNextPage,
        loadingNextPage = _ref$loadingNextPage === void 0 ? false : _ref$loadingNextPage,
        _ref$filters = _ref.filters,
        filters = _ref$filters === void 0 ? {} : _ref$filters,
        _ref$ModelClass = _ref.ModelClass,
        ModelClass = _ref$ModelClass === void 0 ? null : _ref$ModelClass;

    _classCallCheck(this, CollectionManager);

    Object.assign(this, {
      list: list,
      pagination: pagination,
      refreshing: refreshing,
      loadingNextPage: loadingNextPage,
      filters: filters,
      ModelClass: ModelClass
    });
  } // Factory Function


  _createClass(CollectionManager, [{
    key: "update",

    /**
     * Update the collection.
     *
     * @param {object} data - API response data
     * @param {boolean} append - Optional, add to the current list if `true`. Replace the
     *                           current list if false. Defaults to `false`.
     */
    value: function update(data) {
      var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.list = [].concat(_toConsumableArray(append ? this.list : []), _toConsumableArray(data.results));
      this.pagination = _pagination["default"].create(_objectSpread({}, this.pagination, {
        next: data.next,
        previous: data.previous,
        totalCount: data.count
      }));
      return this;
    }
    /**
     * Refresh the collection.
     */

  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.refreshing = true;
                _context.prev = 1;
                _context.next = 4;
                return this.ModelClass.api.list({
                  pagination: this.pagination,
                  filters: this.filters
                });

              case 4:
                response = _context.sent;
                return _context.abrupt("return", this.update(response));

              case 6:
                _context.prev = 6;
                this.refreshing = false;
                return _context.finish(6);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1,, 6, 9]]);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
    /**
     * Advance to the next page and refresh the collection.
     */

  }, {
    key: "nextPage",
    value: function nextPage() {
      this.pagination.setNextPage();
      return this.refresh();
    }
    /**
     * Go back to the previous page and refresh the collection.
     */

  }, {
    key: "prevPage",
    value: function prevPage() {
      this.pagination.setPrevPage();
      return this.refresh();
    }
    /**
     * Get the next page for a collection and add this page
     * to the collection.
     */

  }, {
    key: "addNextPage",
    value: function () {
      var _addNextPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.pagination.next === null)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.loadingNextPage = true;
                this.pagination = _pagination["default"].create(_objectSpread({}, this.pagination, {
                  page: this.pagination.page + 1
                }));
                _context2.prev = 4;
                _context2.next = 7;
                return this.ModelClass.api.list({
                  pagination: this.pagination,
                  filters: this.filters
                });

              case 7:
                response = _context2.sent;
                return _context2.abrupt("return", this.update(response, true));

              case 9:
                _context2.prev = 9;
                this.loadingNextPage = false;
                return _context2.finish(9);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4,, 9, 12]]);
      }));

      function addNextPage() {
        return _addNextPage.apply(this, arguments);
      }

      return addNextPage;
    }()
  }], [{
    key: "create",
    value: function create() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      opts = opts || {};
      return new CollectionManager(opts);
    }
  }]);

  return CollectionManager;
}();

exports["default"] = CollectionManager;